// scss
import '../stylesheets/products.scss'

// js
import imagesLoaded from "imagesloaded/imagesloaded.pkgd.min";
import Masonry from 'masonry-layout';
// import LazyLoad from "vanilla-lazyload";
// import $ from 'jquery'
// import 'magnify/dist/js/jquery.magnify'
// import 'magnify/dist/js/jquery.magnify-mobile'

// import Swiper bundle with all modules installed
import Swiper from 'swiper/bundle';
// import styles bundle
import 'swiper/css/bundle';

document.addEventListener("turbo:load", function () {
  const swiper = new Swiper('.swiper', {
    // Optional parameters
    slidesPerView: 4,
    centerInsufficientSlides: true,
    loop: true,

    // If we need pagination
    pagination: {
      el: '.swiper-pagination',
    },

    // Navigation arrows
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },

    breakpoints: {
      320: {
        // spaceBetween: 10,
        slidesPerView: 1
      },
      768: {
        spaceBetween: 5,
        slidesPerView: 4
      }
    }

    // And if we need scrollbar
    // scrollbar: {
    //   el: '.swiper-scrollbar',
    // },
  });

  var grid = document.querySelector('.masonary-layout');
  var msnry;

  imagesLoaded(grid, function () {
    console.log('all images are loaded');
    // init Isotope after all images have loaded
    msnry = new Masonry(grid, {
      // itemSelector: '.grid-item',
      // columnWidth: '.grid-sizer',
      percentPosition: true
    });

    msnry.layout()
  });

  (function () {
    var callback_loaded = function (element) {
      msnry.layout()
      // logElementEvent("👍 LOADED", element);
    };

    var ll = new LazyLoad({
      callback_loaded: callback_loaded
    });
  })();
});
